import { render, staticRenderFns } from "./comp_CheckoutStep-confirm-Talo--active.vue?vue&type=template&id=5591484a&scoped=true"
import script from "./comp_CheckoutStep-confirm-Talo--active.vue?vue&type=script&lang=js"
export * from "./comp_CheckoutStep-confirm-Talo--active.vue?vue&type=script&lang=js"
import style0 from "./comp_CheckoutStep-confirm-Talo--active.vue?vue&type=style&index=0&id=5591484a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5591484a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VIcon,VProgressCircular})
